export default __webpack_public_path__ + "static/media/kegs.306106b8.svg";